module.exports = __webpack_public_path__ + "img/arrows-to-line.cb90f202.svg";